export default __webpack_public_path__ + "static/media/retreat-img1.448deeb4.jpg";